export default class LinkedDocument {
    constructor (dto) {
        this.id = 0;
        this.mainDocumentId = 0;
        this.linkedDocumentId = 0;
        this.description = '';
        this.author = '';
        this.linkDate = '';

        if (dto) {
            Object.keys(dto).forEach((key) => {
                this[key] = dto[key];
            });
        }
    }
}
